import React from 'react';
import { ArrowRightIcon, ListChecksIcon, MapIcon, MegaphoneIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { solutionSteps } from '../../data/salesContent';
import { CHECKOUT_URL } from '../../data/product';
const stepIcons = [ListChecksIcon, MapIcon, MegaphoneIcon];
const stepColors = ['bg-pumpkin text-ink', 'bg-plum text-cream', 'bg-lime text-ink'];
export function SolutionSection() {
  return <section className="border-t border-line bg-navy py-8 sm:py-12" aria-labelledby="solution-title" data-id="element-176" data-mp="dct5sfaosl0z">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-177" data-mp="ib4hywogf7md">
        <div className="text-center" data-id="element-178" data-mp="mcg9x8usw4xq">
          <h2 id="solution-title" className="font-display text-[32px] font-extrabold leading-[1] tracking-tight text-cream sm:text-6xl" data-id="element-179" data-mp="mbeoqbk2m22a">
            Open It. Set Up the Gym. <span className="text-pumpkin" data-id="element-180" data-mp="3qpmw9g4znjef">Start Teaching.</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-181" data-mp="3ur82wjqxj1g6">
            Visual games, stations and complete lessons designed to be understood quickly.{' '}
            <span className="font-semibold text-lime" data-id="element-182" data-mp="2xll5hblr46h2">That’s it.</span>
          </p>
        </div>

        <ol className="mt-5 grid gap-2.5 md:grid-cols-[1fr_auto_1fr_auto_1fr] md:items-stretch" data-id="element-183" data-mp="2sucw2fkf8l3w">
          {solutionSteps.map((s, i) => {
          const Icon = stepIcons[i];
          return <React.Fragment key={s.title} data-id="element-184" data-mp="2ix75d8fpyw47" data-mpi={i}>
                <li className="flex h-full items-center gap-4 rounded-2xl border border-line bg-night p-4 md:flex-col md:items-start md:p-6" data-id="element-185" data-mp="2iuue24o2n9eh">
                  <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${stepColors[i]}`} data-id="element-186" data-mp="29vqvr2wqay11">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-187" data-mp="24y7fxykdud6z" />
                  </span>
                  <div data-id="element-188" data-mp="855orvbtyzyf">
                    <p className="font-display text-xl font-extrabold uppercase leading-none text-cream md:text-2xl" data-id="element-189" data-mp="84dr8eyoas5i">
                      <span className="mr-2 text-xs font-bold tracking-[0.14em] text-muted" data-id="element-190" data-mp="33q1dwm6khcv">{s.step}</span>
                      {s.title}
                    </p>
                    <p className="mt-1.5 text-sm leading-snug text-muted" data-id="element-191" data-mp="22dsxxvnwtbdn">{s.text}</p>
                  </div>
                </li>
                {i < solutionSteps.length - 1 && <li aria-hidden="true" className="hidden items-center justify-center md:flex" data-id="element-192" data-mp="1smeqn1ppv79y">
                    <ArrowRightIcon className="h-6 w-6 text-pumpkin" data-id="element-193" data-mp="2gbzb5p1iqclc" />
                  </li>}
              </React.Fragment>;
        })}
        </ol>

        <div className="mt-5 flex justify-center" data-id="element-194" data-mp="26ecvv1gb4j0u">
          <CtaButton href={CHECKOUT_URL} data-id="element-195" data-mp="26djopzdfrri6">Yes — I Want My Halloween PE Week Planned</CtaButton>
        </div>
      </div>
    </section>;
}